import { render, staticRenderFns } from "./ChemicalLossList.vue?vue&type=template&id=941548b4&scoped=true&"
import script from "./ChemicalLossList.vue?vue&type=script&lang=js&"
export * from "./ChemicalLossList.vue?vue&type=script&lang=js&"
import style0 from "./ChemicalLossList.vue?vue&type=style&index=0&id=941548b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941548b4",
  null
  
)

export default component.exports